:host {
  .message-tips {
    &__title {
      display: flex;
      align-items: center;
      color: #333333;
      color: var(--font-primary);
      font-size: 15px;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 10px;

      img {
        width: 22px;
        height: 22px;
        margin-right: 5px;
        object-fit: contain;
      }
    }

    &__description {
      color: #666666;
      color: var(--font-secondary);
      letter-spacing: 0;
      line-height: 24px;

      a {
        color: #9a97f3;
        color: var(--primary-color);
        text-decoration: none;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 5px;
      }
    }
  }
}
